<template>
    <van-search 
      :placeholder="placeHolder" 
      @search="onSearch" 
      v-model="value"
      background="#4A90E2"
      show-action
      shape="round"
      class="isearch" >
      <div slot="action" @click="onSearch" class="search">Search</div>
    </van-search>
</template>

<script>
import searchMixin from '@/mixins/searchMixin'
export default {
    mixins: [searchMixin],
}
</script>

<style lang="scss" scoped>
.isearch {
  width: 100%;
  height: 50px;
  color: #CCCCCC;
  font-size: 14px;
    .van-search__content--round {
        height: 32px;
    }
    .van-search__action {
        color: white;
        padding: 0 12px 0 16px;
        font-size: 16px;
        line-height: 24px;
        background-color: #4A90E2;
    }
    .search {
        padding: 4px;
        &:hover {
            color: white;
        }
        &:active {
            color: #333;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/searchGame.vue